export default "__VITE_ASSET__e31b9a10__"